export const CLIENTLIST_TABLE_HEAD = [
  { id: 'id', key: 'client_id', label: 'Client Id', alignRight: false },
  { id: 'client_name', key: 'client_name', label: 'Client Name', alignRight: false },
  { id: 'date_created', key: 'date_created', label: 'Date Created', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Action', alignRight: false }
];
export const VENDOR_LIST_HEAD = [
  { id: 'id', key: 'vendor_id', label: 'Vendor Id', alignRight: false },
  { id: 'vendor_name', key: 'vendor_name', label: 'Vendor Name', alignRight: false },
  { id: 'date_created', key: 'date_created', label: 'Date Created', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Action', alignRight: false }
];
export const PROJECT_LIST_HEAD = [
  { id: 'id', key: 'project_id', label: 'Project Id', alignRight: false },
  { id: 'project_name', key: 'project_name', label: 'Project Name', alignRight: false },
  { id: 'vendor_name', key: 'vendor_name', label: 'Vendor', alignRight: false },
  { id: 'client_name', key: 'client_name', label: 'Client', alignRight: false },
  { id: 'date_created', key: 'date_created', label: 'Date Created', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Action', alignRight: false }
];
export const HEADER_LIST_HEAD = [
  { id: 'id', key: 'header_id', label: 'Header Id', alignRight: false },
  { id: 'header_name', key: 'header_name', label: 'Header Name', alignRight: false },
  { id: 'header_type', key: 'header_type', label: 'Type', alignRight: false },
  { id: 'clients', key: 'clients', label: 'Clients', alignRight: false },
  { id: 'projects', key: 'projects', label: 'Projects', alignRight: false },
  { id: 'date_created', key: 'date_created', label: 'Date Created', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Actions', alignRight: false }
];
export const SCORING_MODEL_LIST_HEAD = [
  { id: 'id', key: 'scoring_model_id', label: 'Scoring Model Id', alignRight: false },
  { id: 'scoring_model_name', key: 'scoring_model_name', label: 'Scoring Model Name', alignRight: false },
  { id: 'external_model_name', key: 'external_model_name', label: 'Linked Model Name', alignRight: false },
  { id: 'required_columns', key: 'required_columns', label: 'Required Columns', alignRight: false }
  // { id: 'created_date', key: 'created_date', label: 'Created Date', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Actions', alignRight: false }
];
export const CATEGORY_FILE_LIST_HEAD = [
  { id: 'id', key: 'id', label: 'Id', alignRight: false },
  { id: 'category_name', key: 'category_name', label: 'File Type', alignRight: false },
  { id: 'clients', key: 'clients', label: 'Client', alignRight: false },
  { id: 'projects', key: 'projects', label: 'Project', alignRight: false },
  { id: 'created_date', key: 'created_date', label: 'Created Date', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false },
  // { id: 'action', label: 'Actions', alignRight: false }
];
export const USER_LIST_HEAD = [
  { id: 'id', key: 'user_id', label: 'User Id', alignRight: false },
  { id: 'email', key: 'email', label: 'User Email', alignRight: false },
  { id: 'access_profile_name', key: 'access_profile_name', label: 'User Role', alignRight: false },
  { id: 'clients', key: 'clients', label: 'Clients', alignRight: false },
  { id: 'projects', key: 'projects', label: 'Projects', alignRight: false }
  // { id: 'created_date', key: 'created_date', label: 'Created Date', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false }
  // { id: 'action', label: 'Action', alignRight: false }
];
export const USER_ROLE_LIST_HEAD = [
  { id: 'id', key: 'UserRole_id', label: 'Role Id', alignRight: false },
  { id: 'access_profile_name', key: 'access_profile_name', label: 'User Role', alignRight: false }
  // { id: 'status', key: 'status', label: 'Status', alignRight: false }
  // { id: 'action', label: 'Action', alignRight: false }
];
export const EXCLUSION_RULE_LIST_HEAD = [
  { id: 'id', key: 'no', label: 'No', alignRight: false },
  { id: 'col_name', key: 'column_name', label: 'Column Name', alignRight: false },
  { id: 'cell_value', key: 'if_cell_value', label: 'If Cell Value', alignRight: false },
  { id: 'value', key: 'value_text', label: 'Value/Text', alignRight: false },
  { id: 'rule_type', key: 'rule_type', label: 'Rule Type', alignRight: false }
  // { id: 'action', label: 'Action', alignRight: false }
];
export const SEGMENTATION_PREVIEW_LIST_HEAD = [
  { id: 'id', key: 'no', label: 'No', alignRight: false },
  { id: 'customer_name', key: 'customer_name', label: 'Customer Name', alignRight: false },
  { id: 'customer_id', key: 'customer_id', label: 'Customer ID', alignRight: false },
  { id: 'phone', key: 'phone', label: 'Phone', alignRight: false },
  { id: 'other_columns', key: 'other_columns', label: 'Other Columns', alignRight: false },
  { id: 'score', key: 'score', label: 'Score', alignRight: false }
  // { id: 'action', label: 'Action', alignRight: false }
];

export const EXCLUSION_RULE_SET_LIST_HEAD = [
  { id: 'filtering_rule_set', key: 'filtering_rule_set', label: 'Filtering Rule Set', align: 'left' },
  { id: 'no_of_rules', key: 'no_of_rules', label: 'No of Rules', align: 'center' },
  { id: 'date_added', key: 'date_added', label: 'Date added', align: 'center' },
  { id: 'active', key: 'active', label: 'Status', align: 'center' },
  { id: 'edit', label: 'Edit', align: 'center' }
];

export const CAMPAIGN_RULE_SET_LIST_HEAD = [
  { id: 'campaign_rule_set', key: 'campaign_rule_set', label: 'Campaign Rule Set', align: 'left' },
  { id: 'no_of_rules', key: 'no_of_rules', label: 'No of Rules', align: 'center' },
  { id: 'date_added', key: 'date_added', label: 'Date added', align: 'center' },
  { id: 'active', key: 'active', label: 'Status', align: 'center' },
  { id: 'edit', label: 'Edit', align: 'center' }
];
function createData(ExclusionRuleList, RulesNo, DateAdded, Status, Edit, price) {
  return {
    ExclusionRuleList,
    RulesNo,
    DateAdded,
    Status,
    Edit,
    price,
    history: [
      {
        date: '1',
        customerId: '11091700',
        amount: 3
      },
      {
        date: '2',
        customerId: 'Anonymous',
        amount: 1
      }
    ]
  };
}

export const EXCLUSION_RULE_SET_LIST_DATA = [
  createData('ER-Project Name', 5, '22 Aug 2022', true, '', ''),
  createData('Ice cream sandwich', 237, '22 Aug 2022', true, 4.3, 4.99),
  createData('Eclair', 262, '22 Aug 2022', false, 6.0, 3.79),
  createData('Cupcake', 305, '22 Aug 2022', true, 4.3, 2.5),
  createData('Gingerbread', 356, '22 Aug 2022', false, 3.9, 1.5)
];

export const COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD = [
  { id: 'no', key: 'no', label: 'No', align: 'left' },
  { id: 'col_name', key: 'column_name', label: 'Column Name', align: 'left' },
  { id: 'cell_value', key: 'if_cell_value', label: 'If Cell Value', align: 'center' },
  { id: 'value', key: 'value_text', label: 'Value/Text', align: 'center' },
  // { id: 'rule_type', key: 'rule_type', label: 'Rule Type', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' }
];

export const MODULE_ROLE = {
  exclusionrule: 'exclusionrule',
  headers: 'headers',
  collectiondatafile: 'collectiondatafile',
  usercustompermissions: 'usercustompermissions',
  collectiondata: 'collectiondata',
  masterfile: 'masterfile',
  tokenuser: 'tokenuser',
  scoringmodel: 'scoringmodel',
  createclient: 'createclient',
  user: 'user',
  extractcolumnmap: 'extractcolumnmap',
  project: 'project',
  createvendor: 'createvendor',
  campaignrule: 'campaignrule',
  logentry: 'logentry',
  customuser: 'customuser',
  usercustompermissionssubmodule: 'usercustompermissionssubmodule',
  categoryname: 'categoryname',
  userrole: 'userrole'
};
